export const config = {
  AboutIntro: {
    title: 'About you',
    description: 'Tell us a little bit about yourself so your Personal Stylist can prepare for your appointment.',
  },
};
